import { ClassNames } from '@emotion/core'
import React from 'react'
import Modal from 'react-modal'

import { HippoVideo } from './HippoVideo'
import { Link } from './Link'
interface Props {
  showModal: boolean
  hippoVideoId: string
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  hippoLink?: string
  hippoLinkText?: string
}
export const HippoVideoPopup: React.FC<Props> = ({
  showModal,
  setShowModal,
  hippoVideoId,
  hippoLink,
  hippoLinkText,
}) => {
  return (
    <React.Fragment>
      <ClassNames>
        {({ css }) => {
          const overlayStyle = css`
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.65);
            position: fixed;
            top: 0;
            left: 0;
            z-index: 40;
          `
          const modalStyle = css`
            position: fixed;
            width: 100%;
            max-width: 800px;
            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
            outline: none;
            margin: 0px auto;
            border-radius: 0.5rem;
            overflow: hidden;
            box-sizing: border-box;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          `

          const linkStyle = css`
            a.body-1 {
              display: block !important;
              background-color: #fff !important;
              text-align: center !important;
              border-top: 1px solid #efeff0;
              padding: 1rem 0;
              margin: 0;

              &:hover {
                opacity: 1;
                background-color: rgba(255, 255, 255, 0.9) !important;
              }
            }
          `

          return (
            <Modal
              isOpen={showModal}
              className={modalStyle}
              overlayClassName={overlayStyle}
              ariaHideApp={false}
              onRequestClose={() => {
                document.body.style.overflow = 'auto'
                setShowModal(false)
              }}
            >
              <HippoVideo hippoVideoId={hippoVideoId} />

              {hippoLink && hippoLinkText && (
                <div className={linkStyle}>
                  <Link className="body-1" href={hippoLink} withArrow>
                    {hippoLinkText}
                  </Link>
                </div>
              )}
            </Modal>
          )
        }}
      </ClassNames>
    </React.Fragment>
  )
}
